module.exports = __webpack_public_path__ + "static/scale-model-of-tropical-discovery-in-denver-colorado-636b1c0636708b0040fa46b8da51e382.png";